import { SurfaceKind } from './capabilities/types'

export type PlayerView = 'normal' | 'above' | 'below' | 'flat'
export type { SurfaceKind }

export function surfaceForView(view: PlayerView): SurfaceKind {
  return view === 'flat' ? 'flat' : 'sphere'
}
